// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__1dao8","col":"CardReaderDesc_col__3lr-W","label":"CardReaderDesc_label__3TYh9"};